import moment from "moment";
import { useAppContext } from "../../../AppProvider.jsx";
import { useTypes } from "../../../utilities/types.js";
import { useShipmentDetailsContext } from "../providers/hooks";

export const ShipmentValues: React.FC = () => {
  const { dictionary, accessTokenPayload } = useAppContext();
  const { data } = useShipmentDetailsContext();
  const { currencies } = useTypes();

  const valueCurrency = {
    cashOnDeliveryValueCurrency: currencies.find(
      (c) => c.value === data.cashOnDeliveryValueCurrency,
    ),
    insuranceValueCurrency: currencies.find(
      (c) => c.value === data.insuranceValueCurrency,
    ),
    goodsValueCurrency: currencies.find(
      (c) => c.value === data.goodsValueCurrency,
    ),
  };

  return (
    <>
      {/* Goods Value */}
      <div className="d-flex justify-content-between w-100">
        <label className="label-2">{dictionary.dimensions.goods_value}</label>
        <label className="label-1">
          {data.goodsValue ? <>{data.goodsValue.toFixed(2)}</> : "-"}{" "}
          {valueCurrency.goodsValueCurrency?.label}
        </label>
      </div>

      {/* Insurance Value */}
      <div className="d-flex justify-content-between w-100">
        <label className="label-2">
          {dictionary.dimensions.insurance_value}
        </label>
        <label className="label-1">
          {data.insuranceValue ? <>{data.insuranceValue.toFixed(2)}</> : "-"}{" "}
          {valueCurrency.goodsValueCurrency?.label}
        </label>
      </div>

      {/* Cash on delivery Value */}
      <div className="d-flex justify-content-between w-100 mb-3">
        <label className="label-2">
          {dictionary.dimensions.cash_on_delivery_value}
        </label>
        <label className="label-1">
          {data.cashOnDeliveryValue ? (
            <>{data.cashOnDeliveryValue.toFixed(2)}</>
          ) : (
            "-"
          )}{" "}
          {valueCurrency.cashOnDeliveryValueCurrency?.label}
        </label>
      </div>
      {data.cashOnDeliveryValue && (
        <>
          <hr />

          <label className="label-3 mb-2">
            {dictionary.actions.details} {dictionary.options.cash_on_delivery}
          </label>
          {/* Cash on delivery Method */}
          <div className="d-flex justify-content-between w-100">
            <label className="label-2">
              {dictionary.words.cash_on_delivery_method}
            </label>
            <label className="label-1">
              {data.cashOnDeliveryCollectionMethod?.name || "-"}
            </label>
          </div>

          {data.ownerId === accessTokenPayload.owner && (
            <>
              <div className="d-flex justify-content-between w-100">
                <label className="label-2">
                  {dictionary.dates.collected_date}
                </label>
                <label className="label-1">
                  {moment(data.codCollectedDate).format("DD/MM/YYYY") || "-"}
                </label>
              </div>

              <div className="d-flex justify-content-between w-100 mb-3">
                <label className="label-2">
                  {dictionary.dates.liquidated_date}
                </label>
                <label className="label-1">
                  {moment(data.codLiquidatedDate).format("DD/MM/YYYY") || "-"}
                </label>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};
